// extracted by mini-css-extract-plugin
export default {"main":"GlobalNav-module__main___jfEt2"};